import { observer } from 'mobx-react-lite'
import React, { useContext, useMemo } from 'react'

// evertel
import { Row, Card, CardBody, Icon, Text, Col, Media, PhotoGalleryContext } from '@evertel/web/ui'
import { useDocumentService } from '@evertel/service'
import { sortMediaByType } from '@evertel/utils'
import { APIDataMediaToNormalizedMedia } from '@evertel/media'
import Wrapper from './Wrapper'
import { APIDataMedia } from '@evertel/types'


export interface MediaReadWidgetProps {
    id: string
    htmlId?: string
    value: number[]
    title: string
}

const MediaReadWidget: React.FC<MediaReadWidgetProps> = observer(({
    htmlId,
    value,
    title,
    ...otherProps
}) => {

    const photoGallery = useContext(PhotoGalleryContext)
    const meta = useDocumentService<{ media: APIDataMedia[] }>('meta')

    const labelId = `label-${htmlId}`
    const descriptionId = `description-${htmlId}`

    const mediaIds = useMemo(() => {
        if (!value) return []

        // old bad-data case
        // @ts-expect-error historical issue
        const uploaded = value?.uploaded
        const raw = uploaded ?? value

        return Array.isArray(raw) ? raw : [raw]
    }, [value])

    const foundMedia = meta.media?.filter((m) => mediaIds?.find((v) => v === m.id)) || []
    const mediaSorted = sortMediaByType(foundMedia.map(m => APIDataMediaToNormalizedMedia(m)))

    const visualMedia = mediaSorted.filter(m => ['image', 'video'].includes(m.mediaType))
    const files = mediaSorted.filter(m => !['image', 'video'].includes(m.mediaType))

    const audio = mediaSorted.filter(m => m.mediaType === 'audio')
    const galleryMedia = [...visualMedia, ...audio]

    const onClickMedia = (idx?: number) => {
        photoGallery.setMedia(galleryMedia)
        photoGallery.setSelectedIndex(idx)
        photoGallery.setVisible(true)
    }

    //console.log('MEDIA', title, value)
    const maxMediaWidth = 250
    const maxMediaHeight = 150

    return (
        <Wrapper
            title={title}
            labelId={labelId}
            descriptionId={descriptionId}
            {...otherProps}
        >
            <Card>
                <CardBody>
                    <Row>
                        {(!mediaSorted?.length) &&
                            <Col align="center">
                                <Icon name="image-slash" color="body-color" />
                                <Text color="body-color" italic>
                                    No {title} selected.
                                </Text>
                            </Col>
                        }
                    </Row>
                    {/* Other Media Types Row */}
                    <Row style={{ flexWrap: 'wrap' }}>
                        {files.map((m) => (
                            <div
                                key={m.id}
                                className="mt-2 me-3"
                            >
                                <Media
                                    media={m}
                                    enableContextMenu={true}
                                    enableHover={m.mediaType === 'audio'}
                                    width={maxMediaWidth}
                                    height={maxMediaHeight}
                                    rounded
                                />
                            </div>
                        ))}
                    </Row>
                    {/* Images and Videos Row */}
                    <Row style={{ flexWrap: 'wrap' }}>
                        {visualMedia.map((m, idx) => (
                            <button
                                key={m.id}
                                className="mt-2 me-2"
                                onClick={m.mediaType === 'image' ? () => onClickMedia(idx) : undefined}
                                title={`View ${m.mediaType}: ${m.fileName} `}
                                aria-label={`View ${m.mediaType}: ${m.fileName} `}
                            >
                                <Media
                                    media={m}
                                    enableContextMenu={true}
                                    enableHover={true}
                                    width={maxMediaWidth}
                                    height={maxMediaHeight}
                                    rounded
                                />
                            </button>
                        ))}
                    </Row>
                </CardBody>
            </Card>
        </Wrapper>
    )
})

export {
    MediaReadWidget
}
